export class ProductListUtil {
    static getResponsiveClass(businessUnit: string, productCategory: string, columnName: string): string {
        if (!businessUnit || !productCategory || !columnName) return "";

        businessUnit = businessUnit.toLowerCase().trim();
        productCategory = productCategory.toLowerCase().trim();
        columnName = columnName.trim();

        if (businessUnit === "truck") {

            if (productCategory === "banden" || productCategory === "banden_gebruikt") {
                switch (columnName) {
                    case "3pmsf":
                        return "d-1024px-none";
                }
            }

            if (productCategory === "wielen" || productCategory === "wielen_gebruikt") {
                switch (columnName) {
                    case "ventHoles":
                        return "d-1440px-none";
                    case "etValue":
                        return "d-1220px-none";
                    case "boltHoleType":
                        return "d-1024px-none";
                }
            }
        }

        if (businessUnit === "agricultural") {

            if (productCategory === "banden" || productCategory === "banden_gebruikt") {
                switch (columnName) {
                    case "loadSpeedIndexTotal":
                        return "d-1440px-none";
                    case "carcassConstruction":
                        return "d-1440px-none";
                    case "tlTt":
                        return "d-1220px-none";
                    case "plyRating":
                        return "d-1024px-none";
                    case "tread":
                        return "d-1024px-none";
                }
            }

            if (productCategory === "wielen" || productCategory === "wielen_gebruikt") {
                switch (columnName) {
                    case "":
                        return "d-1440px-none";
                    case "colour":
                        return "d-1220px-none";
                    case "itemCondition":
                        return "d-1220px-none";
                    case "boltHoleType":
                        return "d-1024px-none";
                }
            }
        }

        if (businessUnit === "otr") {

            if (productCategory === "banden" || productCategory === "banden_gebruikt") {
                switch (columnName) {
                    case "plyRating":
                        return "d-1440px-none";
                    case "usage":
                        return "d-1220px-none";
                    case "itemCondition":
                        return "d-1220px-none";
                }
            }
        }

        return "";
    }
}